const FormStep = ({ children, title, onBack = null, onNext = null, isNextDisabled = false, hideBackButton = false }) => {
  return <div className="lde-form-page">
    {/* <div className="lde-form-page__head">
        <h2>{title}</h2>
    </div> */}
    <div className="lde-form-page__body">
        {children}
    </div>
    <div className="lde-form-page__actions">
      {onBack && !hideBackButton && <button className="btn btn-step-back" onClick={onBack}>Previous</button>}
      {onNext && <button className="btn btn-step-next" onClick={onNext} disabled={isNextDisabled}>Continue</button>}
    </div>
  </div>
};

export default FormStep;
